<template>
    <el-drawer :modal="false" 
        title="Preview Financial Analysis"
        :visible.sync="drawerFinancialAnalysis"
        class="drawer-financial-analysis"
        size="80%"
				@close="handleClose"
    >
        <div slot="title">
            <b-row>
                <b-col cols="12" class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 mr-4">Preview Financial Analysis</h3>
                    <b-col cols="12" md="4" class="d-flex align-items-center justify-content-center">
                        <b-row>
                            <b-col cols="6" md="auto" class="text-md-center text-right">
                                <el-button name="preview_kyc" type="text" @click="previewReport">
                                    <div class="d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                                        <p class="text-xs mx-1">Preview</p>
                                    </div>
                                </el-button>
                                <el-button type="text" :disabled="isGenerateReport" @click.prevent="generateReport">
                                    <div class="d-flex align-items-center">
                                        <i class="fa fa-download fa-md text-secondary"></i>
                                        <p class="text-xs mx-1">Generate Report</p>
                                    </div>
                                </el-button>
                                <el-button type="text" v-show="false">
                                    <div class="d-flex align-items-center">
                                        <p class="text-xs mx-1">Download PDF</p>
                                    </div>
                                </el-button>
                            </b-col>
                            <b-col cols="6" md="auto" class="text-md-center text-left">
                                <el-button type="text" :disabled="sendToCustomer">
                                    <div class="d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480v-83.6c0-4 1.5-7.8 4.2-10.7l167.6-182.9c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8l-88.3-44.2C7.1 311.3.3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"/></svg>
                                        <p @click="sendReportToCustomer" class="text-xs mx-1">Send to customer</p>
                                    </div>
                                </el-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-col>
            </b-row>
        </div>
        <div class="m-5">
            <el-collapse v-model="collapseItem">
                <b-row>
                    <b-col cols="12" md="6">
                        <el-collapse-item name="6" class="my-3">
                            <div slot="title" class="collapse-header">
                                <h3 class="mb-0">Cash Flow Statement</h3>
                            </div>
                            <DrawerCashFlowStatement @refresh-financial="getFinancialProposal" :financial_proposal="financial_proposal"/>
                        </el-collapse-item>
                    </b-col>
                    <b-col cols="12" md="6">
                        <el-collapse-item name="7" class="my-3">
                            <div slot="title" class="collapse-header px-3">
                                <h3 class="mb-0">Net Worth Statement</h3>
                            </div>
                            <DrawerNetWorthStatement :financial_proposal="financial_proposal"/>
                        </el-collapse-item>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <el-collapse-item name="8" class="my-3">
                            <div slot="title" class="collapse-header px-3">
                                <h3 class="mb-0">Bank</h3>
                            </div>
                            <el-table class="bank-eligibility table-responsive align-items-center table-flush"
                                        header-row-class-name="thead-light"
                                        :data="tableData"
                                        :default-sort="{ prop: 'bank_name', order: 'ascending' }"
                                        highlight-current-row
                                        @current-change="handleCurrentChange"
                                        row-key="id">
                                <el-table-column label="Name"
                                                min-width="160px"
                                                prop="bank_name"
                                                sortable>
                                    <template v-slot="{row}">
                                    <b>{{row.bank_name}}</b>
                                    </template>
                                </el-table-column>
    
                                <el-table-column label="Estimated Best Rate (%)"
                                                min-width="100px"
                                                prop="bank_loan_eligible_interest"
                                                sortable>
                                    <template v-slot="{row}">
                                    <b style="padding-left:50px">{{ row.bank_loan_eligible_interest | moneyFormatter }}</b>
                                    </template>
                                </el-table-column>
    
                                <el-table-column label="Eligibility Amount (RM)"
                                                min-width="150px"
                                                prop="bank_loan_eligibility_amount"
                                                sortable>
                                    <template v-slot="{row}">
                                        <b-col>
                                            <b-row style="padding-left:50px">
                                                <b-img width="20px" fluid src="/img/bank_score_recommended_v2.png"></b-img>&nbsp;
                                                <b>{{ row.bank_loan_eligibility_amount | moneyFormatter}}</b>
                                            </b-row>
                                        </b-col>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="90px">
                                    <template v-slot="{row}" v-if="selects.bank">
                                        <base-button type="primary" size="sm" v-show="row.bank_id == selects.bank.bank_id" class="disabled">selected</base-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-collapse-item>
                    </b-col>
                </b-row>
            </el-collapse>
        </div>
        <PreviewModal ref="preview_modal"></PreviewModal>
    </el-drawer>
</template>
<script>
import { Drawer, Collapse, CollapseItem, Button, Table, TableColumn } from 'element-ui'
import DrawerCashFlowStatement from '@/views/InitialProposal/Drawers/DrawerCashFlowStatement'
import DrawerNetWorthStatement from '@/views/InitialProposal/Drawers/DrawerNetWorthStatement'
import { axios, services, getHeader, notifyFunctionMixin, swal } from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState } from 'pinia'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import PreviewModal  from '@/components/Modal/PreviewModal'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
    props: ['proposal', 'current_customer'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
				DrawerCashFlowStatement,
        DrawerNetWorthStatement,
        PreviewModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Drawer.name]: Drawer,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
    },
    data() {
        return {
            tableData: [],
            collapseItem: ['6', '7'],
            drawerFinancialAnalysis: false,
            financial_proposal: [],
            selects: {
                bank: {
                    bank_id: null,
                },
            },
            isGenerateReport: false,
            sendToCustomer: false,
            kyc_access_token: localStorage.kyc_token != null ? JSON.parse(localStorage.kyc_token) : null,
        }
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
    },
    created() {
        this.getPersonalLoanBanks()
    },
    methods: {
        viewFinancialAnalysis() {
            this.drawerFinancialAnalysis = !this.drawerFinancialAnalysis;
            if(this.drawerFinancialAnalysis)
            {
                this.getFinancialProposal();
            }
        },
        getFinancialProposal() {
            const postData = {
                im2u_customer_id: this.current_customer.customer_id,
                psal_id: this.proposal.psal_id,
                customer_name: this.current_customer.name,
                customer_email: this.current_customer.email,
                customer_nric: this.current_customer.nric,
                agent_name: this.current_customer.se != null ? this.current_customer.se.name : this.current_customer.sse != null ? this.current_customer.sse.name : null,
                agent_email: this.current_customer.se != null ? this.current_customer.se.email : this.current_customer.sse != null ? this.current_customer.sse.email : null,
                agent_contact_number: this.current_customer.se != null ? this.current_customer.se.name : this.current_customer.sse != null ? this.current_customer.sse.name : null,
            };

            axios.post(services.financial_proposal + 'create_customer_financial_proposal_data', postData, {headers: getHeader()} )
            .then(res=>{
                if(res.status == 200)
                {
                    this.financial_proposal = res.data.data;
                    const customer_eligibility = res.data.data.customer_eligibility
                    if(customer_eligibility != null)
                    {
                        this.selects.bank.bank_id = res.data.data.customer_eligibility.bank_id;
                    }

                    // overwrite customer value to admin value on financial proposal customer incomes
                    const customer_incomes = res.data.data.customer_incomes.data
                    this.financial_proposal.customer_incomes.data = customer_incomes.map(income => {
                        if(income.admin_value == 0 || income.admin_value == null) {
                            return {...income, admin_value: income.customer_value}
                        }
                        return income;
                    })
                    // overwrite customer value to admin value on financial proposal customer liabilities
                    const customer_liabilities = res.data.data.customer_liabilities
                    this.financial_proposal.customer_liabilities = customer_liabilities.map(liability => ({
                        ...liability,
                        admin_curr_outstanding: liability.admin_curr_outstanding !== null ? liability.admin_curr_outstanding : liability.customer_curr_outstanding,
                        admin_curr_installment: liability.admin_curr_installment !== null ? liability.admin_curr_installment : liability.customer_curr_installment
                    }));
                    console.log('ffds', this.financial_proposal.customer_liabilities)
                    // overwrite customer value to admin value on financial proposal customer expenses
                    const customer_expenses = res.data.data.customer_expenses
                    this.financial_proposal.customer_expenses = customer_expenses.map(expense => {
                        if(expense.admin_month_value == 0 || expense.admin_month_value == null) {
                            return {...expense, admin_month_value: expense.customer_month_value}
                        }
                        return expense;
                    })
                }
            })
            .catch(e => {
                _gNotif.errorFunction(e)
            })
        },
        getPersonalLoanBanks(){
            axios.get(services.customer + 'customer/' + this.current_customer.customer_id +'/dsr.eligibilities?formula=PL', {headers: getHeader()})
            .then(res=>{
                this.tableData = res.data.data.bank_eligibilities
                const limit = this.auth_user.subscription.privileges.scpk_limit_bank
                const prefferedBanks = this.auth_user.subscription.scrb_banks
                if(prefferedBanks.length > 0){
                    this.tableData.forEach((bank, index) => {
                        if(prefferedBanks.find((item) => item.bank_code === bank.bank_code)){
                            this.tableData.unshift(this.tableData.splice(index, 1)[0]);
                        }
                    })
                    this.tableData.length = prefferedBanks.length
                }else{
                    if(limit){
                        this.tableData.length = limit
                    }
                }
                this.tableData.sort((a, b) => parseFloat(a.bank_max_loan_amount) > parseFloat(b.bank_max_loan_amount) ? -1 : 1);
            })
            .catch(e =>{
                _gNotif.errorFunction(e)
            })
        },
        handleCurrentChange(selectedRow){
            this.$notify({
                message: '<b>' + selectedRow.bank_name + ' is selected as the recommended bank for this customer.</b>',
                timeout: 1500,
                icon: 'ni ni-bulb-61',
                type: 'success',
            });
            this.selects.bank = selectedRow;
            const postData = {
                financial_proposal_id: this.financial_proposal.financial_proposal_id,
                im2u_request_id: this.proposal.psal_id,
                bank_id: selectedRow.bank_id,
                bank_name: selectedRow.bank_name,
                // fintos_score: selectedRow.Fintos_Score,
                loan_interest: selectedRow.bank_loan_eligible_interest,
                loan_eligible: selectedRow.bank_loan_eligibility_amount,
            }

            axios.post(services.financial_proposal + 'customer_eligibility', postData,{ headers: getHeader() })
            .then ( response => {
                this.getSelectedEligibilityData();
            })
            .catch ( error => {
                console.log(error.response.status)
                _gNotif.errorFunction(error, "Update Customer Eligibility")
            });
        },
        getSelectedEligibilityData() {
            axios.get(services.financial_proposal + 'get_customer_loan_eligibility_by_financial_proposal_id/' + this.financial_proposal.financial_proposal_id ,{ headers: getHeader() })
            .then ( response => {
                this.selects.bank = response.data.data[0];
            })
            .catch ( error => {
                console.log(error.response.status)
                _gNotif.errorFunction(error, "Get Customer Loan Eligibility")
            });
        },
        generateReport() {
            const postData = {
                financial_proposal_id: this.financial_proposal.financial_proposal_id,
                action: 'download',
            };

            this.isGenerateReport = true
            this.$notify({
                message: '<b>Generating Customer Financial Proposal Report.<br>This may takes a few seconds.<br>When finished, the pdf report will be downloaded automatically.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
            });

            axios.post(services.financial_proposal + 'financial_proposal_report', postData, 
                {
                    headers: getHeader(),
                    responseType: 'blob'
                } 
            )
            .then(res=>{
                const fileName = this.current_customer.name + ' ' + this.current_customer.created_at +'.pdf';
                this.createDownloadFileLink(res.data, fileName);
                this.$notify({
                    message:
                        '<b>Financial Proposal Report for <b>'+this.current_customer.name+'</b> Successfully Generated.',
                    timeout: 1000,
                    icon: 'ni ni-bell-55',
                    type: 'success',
                });
                this.isGenerateReport = false;
            })
            .catch(e => {
                this.isGenerateReport = false;
                _gNotif.errorFunction(e)
            })
        },
        previewReport() {
            axios.get(services.financial_proposal + 'get_latest_report_by_customer_id/' + this.current_customer.customer_id ,{ headers: getHeader() })
            .then ( response => {
                this.$refs.preview_modal.preview(response.data.attachment_url, response.data.attachment.attach_file);
            })
            .catch ( error => {
                _gNotif.errorFunction(error, "Preview report error.")
            });
        },
        sendReportToCustomer() {
            swal.fire({
                title: 'Are you sure?',
                text: "Confirm to send financial proposal report to " + this.current_customer.name + " ?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, confirm!'
            }).then((result) => {
                if(result.isConfirmed) {
                    this.sendToCustomer = true;
                    axios.get(services.financial_proposal + 'send_email_to_customer/' + this.current_customer.customer_id ,{ headers: getHeader() })
                    .then ( response => {
                        if(response.status == 200) {
                            this.$notify({
                                message:
                                    '<b>Financial Proposal Report successfully send to <b>'+this.current_customer.name+'</b>',
                                timeout: 1000,
                                icon: 'ni ni-bell-55',
                                type: 'success',
                            });
                        }
                    })
                    .catch ( error => {
                        _gNotif.errorFunction(error, "Send Report to customer failed.")
                    });
                    this.sendToCustomer = false;
                }
                
            });
        },
				handleClose(){
					console.log('DRAWER CLOSED');
					initialProposalEventBus.$emit('sync-proposal');
				}
    }
}
</script>